// src/utils/types.ts

// Pattern: Branded Types to avoid primitive obsession and prevent ID mix-ups.
declare const brand: unique symbol
export type Brand<T, TBrand extends string> = T & { [brand]: TBrand }

export type MissionId = Brand<number, 'MissionId'>
export type ApriorMapId = Brand<number, 'ApriorMapId'>
export type ApriorMapVersionId = Brand<number, 'ApriorMapVersionId'>

export const toMissionId = (id: number) => id as MissionId
export const toApriorMapId = (id: number) => id as ApriorMapId
export const toApriorMapVersionId = (id: number) => id as ApriorMapVersionId
